import React from 'react'; // Add this at the top of your file
function StrengthMeter({
  poorPassword,
  weakPassword,
  strongPassword,
  passwordError,
}) {
  return (
    <>
   <ul className="list-group list-group-horizontal mb-3">
        {poorPassword === true ? (
          <li
            className="list-group-item bg-danger col-4"
            style={{ padding: "1px 0px" }}
          ></li>
        ) : (
          ""
        )}
        {weakPassword === true ? (
          <li
            className="list-group-item bg-warning col-4"
            style={{ padding: "1px 0px" }}
          ></li>
        ) : (
          ""
        )}
        {strongPassword === true ? (
          <li
            className="list-group-item bg-success col-4"
            style={{ padding: "1px 0px" }}
          ></li>
        ) : (
          ""
        )}
      </ul>
      
    </>
  );
}

export default StrengthMeter;
